module.exports = {
  appKey: process.env.REACT_APP_KEY,
  transactionKey: process.env.REACT_APP_TRANSACTION_KEY,
  transactionIVKey: process.env.REACT_APP_TRANSACTION_IV_KEY,
};
